import React, { useState } from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que dejar de comer carne?',
    a: 'No, te enseñamos a elegir los cortes que no inflaman.'
  }, {
    q: '¿Es difícil de cocinar?',
    a: 'Todas las recetas están diseñadas para prepararse en menos de 15 minutos.'
  }, {
    q: '¿Funciona si tengo artritis severa?',
    a: 'Sí, este protocolo ayuda a reducir la carga inflamatoria que empeora cualquier condición articular.'
  }, {
    q: '¿Los ingredientes son caros?',
    a: 'Al contrario, nuestras recomendaciones suelen ser más económicas que la comida procesada.'
  }, {
    q: '¿Es un libro físico?',
    a: 'Es un libro digital de descarga inmediata para que empieces hoy mismo.'
  }, {
    q: '¿Puedo tomar café?',
    a: 'Absolutamente, te enseñamos la forma correcta de hacerlo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="bg-white py-24 px-6" data-id="element-39">
      <AnimatedSection className="max-w-3xl mx-auto" data-id="element-40">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-41">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-42">
          {faqs.map((faq, i) => <div key={i} className="border border-brand-gray/20 rounded-2xl overflow-hidden" data-id="element-43">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left bg-brand-cream/30 hover:bg-brand-cream/50 transition-colors" data-id="element-44">
                <span className="font-bold text-lg text-brand-green" data-id="element-45">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-brand-green transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-46" />
              </button>
              <AnimatePresence data-id="element-47">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-48">
                    <div className="p-6 pt-0 bg-brand-cream/30 text-lg" data-id="element-49">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </AnimatedSection>
    </div>;
}